import { Button } from 'components-antd';
import styles from './styles.module.scss';
import { ICON_VARIANT_TYPE, Icons } from 'pages/Workshop/Forms/Icons';
import { Fragment, useState } from 'react';
import {
  CopyFormButton,
  DeleteFormButton,
  EditFormButton,
  ViewFormButton,
  VoidFormButton,
} from './components';
import { VoidFormModal } from '../VoidFormModal';
import { FormsTableStatus } from 'app-constants';

export const FormDetailActions = (props) => {
  const [formVoidModal, setFormVoidModal] = useState<{
    modalType: string;
    formName?: string;
    formId?: string;
  }>({
    modalType: '',
  });

  const {
    flexed,
    formDetails,
    refetchForms,
    inProgressForm,
    selectedFormStatus,
    selectedFormProcess,
  } = props;

  const { isVoid, isCompleted } = formDetails || { isVoid: false, isCompleted: false };

  if (isVoid) return <EditFormButton {...props} />;

  const isFormCreator = formDetails?.isOwner;
  const isWaitingOnOtherForm = selectedFormStatus === FormsTableStatus.WaitingOnOthers;
  const isWaitingOnYouForm = selectedFormStatus === FormsTableStatus.WaitingOnYou;

  const changeModalDetails = (details) => {
    setFormVoidModal({ ...formVoidModal, ...details });
  };

  return (
    <Fragment>
      <div className={styles.formDetailActionButtons} testid="formDetailActionButtons">
        {flexed && <VoidFormButton {...props} changeModalDetails={changeModalDetails} />}

        <ViewFormButton {...props} />

        {!flexed && <VoidFormButton {...props} changeModalDetails={changeModalDetails} />}

        <DeleteFormButton {...props} />

        {isCompleted && isFormCreator && <CopyFormButton {...props} />}
      </div>

      <VoidFormModal
        {...formVoidModal}
        onChangeModalDetails={changeModalDetails}
        formProcessId={selectedFormProcess}
        isWaitingOnYouForm={isWaitingOnYouForm}
        isWaitingOnOtherForm={isWaitingOnOtherForm}
        inProgressForm={inProgressForm}
        refetchForms={refetchForms}
      />
    </Fragment>
  );
};
